<template>
  <div class="goods">
    <!--<van-nav-bar title="快速卖车" left-arrow @click-left="onClickLeft" style="height: 1.28rem"/>-->

    <div style="background: #fff">
      <div class="flex-start" style="height:1.28rem;font-size:0.459rem;color: #333;margin-left: .351rem;border-bottom: 1px solid #E9E9E9;font-weight: bold;">车主基本信息</div>
    </div>
    <div>
      <van-cell-group>
        <!--<van-field class="flex-start" v-model="brand" disabled label="选择车型" right-icon="arrow" placeholder="请选择" @click="showColumns=true;"/>-->
        <van-field class="flex-start" v-model="brand" type="text" label="品牌车型" placeholder="请输入车型" onfocus="this.placeholder=' '" onblur="this.placeholder='请输入车型'"/>
        <van-field class="flex-start" v-model="time" disabled label="上牌时间" right-icon="arrow" placeholder="请选择" @click="showTime=true;"><template v-slot:right-icon><img src="../../image/triangle.png" alt="" style="width: .2rem;margin-top: .3rem;"></template></van-field>
        <van-field class="flex-start" v-model="mileage" type="number" maxlength="6" label="行驶里程" placeholder="请填写行驶里程" onfocus="this.placeholder=' '" onblur="this.placeholder='请填写行驶里程'" @input="toMember"><template v-slot:right-icon>万公里</template></van-field>
        <van-field class="flex-start" v-model="phone" type="number" label="联系电话" maxlength="11" placeholder="请填写联系电话"/>
        <van-field class="flex-start" v-model="name" type="text" label="您的称呼" placeholder="请填写您的称呼（2-6字）" onfocus="this.placeholder=' '" onblur="this.placeholder='请填写您的称呼（2-6字）'"/>
      </van-cell-group>
    </div>

    <div style="background: #fff">
      <div class="flex-start" style="height:1.28rem;font-size:0.459rem;color: #333;margin-left: .351rem;border-bottom: 1px solid #E9E9E9;font-weight: bold;margin-top: .324rem">车辆备注信息</div>
    </div>
    <div style="background: #fff;padding: .324rem">
      <textarea style="padding: .324rem;height: 2.889rem;color: #333;background: #E9E9E9;border: 0;font-size: .378rem;width: -webkit-fill-available;" v-model="information" placeholder="请输入备注信息，如：无重大事故等（选填）"></textarea>
    </div>

    <!--咨询门店-->
    <div style="background: #fff">
      <div class="flex-start" style="height:1.28rem;font-size:0.459rem;color: #333;margin-left: .351rem;font-weight: bold;margin-top: .324rem">咨询门店</div>
    </div>
    <ul style="font-size: .3rem;background: #fff;max-height: 7rem;overflow-y: scroll;">
      <li v-for="item,index in shopList">
        <div v-if="item.distance=='0km'" class="flex-start" style="color: #ccc;min-height: 1.54rem;padding: .325rem 0;margin-left: .405rem;padding-right: .405rem;border-top: 1px solid rgb(233, 233, 233);">
          <div style="width: .4rem"></div>
          <div style="padding: 0 .405rem;width: 100%;">
            <div style="font-size: 0.378rem;">{{item.shopName}}<span style="color: #ccc;font-size: .3rem;margin-left: .1rem;">{{item.distance}}</span></div>
            <div style="color: #ccc;margin-top: .15rem;">{{item.address}}</div>
          </div>
          <div style="width: .4rem"></div>
        </div>
        <div class="flex-start" @click="thiw(index)" v-else style="min-height: 1.54rem;padding: .325rem 0;margin-left: .405rem;padding-right: .405rem;border-top: 1px solid rgb(233, 233, 233);">
          <img v-if="shopListStatus==index" src="../../image/index9.png" alt="" style="width: .4rem">
          <img v-else src="../../image/index8.png" alt="" style="width: .4rem">
          <div style="padding: 0 .405rem;width: 100%;">
            <div style="font-size: 0.378rem;">{{item.shopName}}<span style="color: #999;font-size: .3rem;margin-left: .1rem;">{{item.distance}}</span></div>
            <div style="color: #999;margin-top: .15rem;">{{item.address}}</div>
          </div>
          <img src="../../image/index7.png" alt="" style="width: .4rem">
        </div>
      </li>
    </ul>

    <div style="background: #fff">
      <div class="flex-center" style="color: #F7932B;font-size: .324rem;padding: .324rem 0;margin-top: 0.324rem;">您的卖车需求我们会第一时间帮您</div>
      <div class="flex-center" style="width: 100%;padding-bottom: .378rem;">
        <div class="flex-center" style="background: #e9081a;color: #fff;font-size: .432rem;width: 90%;height: 1.188rem;border-radius: .594rem;" @click="toSucceed">提交</div>
      </div>
    </div>

    <!--选择车型弹框-->
    <van-popup v-model="showColumns" position="bottom" >
      <van-picker show-toolbar :columns="brandColumns" @cancel="showColumns=false;" @confirm="onConfirmBrand"/>
    </van-popup>
    <!--上牌时间弹框-->
    <van-popup v-model="showTime" position="bottom" >
      <!--<van-picker show-toolbar :columns="timeColumns.year" @cancel="showTime=false;" @confirm="onConfirmTime"/>-->
      <van-datetime-picker type="date" @cancel="showTime=false;" @confirm="onConfirmTime"/>
    </van-popup>
  </div>
</template>

<script>
    import {
        NavBar,
        Icon,
        Field,
        CellGroup,
        Popup,
        Picker,
        Toast,
        DatetimePicker
    } from 'vant';

    import request from '@/utils/request'

    export default {
        components: {
            [NavBar.name]: NavBar,
            [Icon.name]: Icon,
            [Field.name]: Field,
            [CellGroup.name]: CellGroup,
            [Popup.name]: Popup,
            [Picker.name]: Picker,
            [Toast.name]: Toast,
            [DatetimePicker.name]: DatetimePicker
        },

        data() {
            return {
                minDate: new Date(),
                showTime: false,
                showColumns:false,
                brand:"",
                time:"",
                mileage:"",
                Ymileage:"",
                name:"",
                phone:"",
                information:"",
                currentDate:"",
                brandColumns: ['大众', '奔驰', '奥迪', '宝马', '福特'],
                shopList:[],
                shopListStatus:0,
                shopListId:""
            };
        },

        methods: {
            toSucceed() {
                //this.$store.commit('setToken', 10)
                //console.log(this.$store,"测试")
                var _this=this;
                var brand=_this.brand;
                var time=_this.time;
                var mileage=_this.mileage;
                var name=_this.name;
                var phone=_this.phone;
                var information=_this.information;

                if(brand == ""){
                    //alert("请选择车型")
                    Toast('请添加车型')
                    return false;
                }else if(time == ""){
                    //alert("请选择车龄")
                    Toast('请选择车龄')
                    return false;
                }else if(mileage == ""){
                    //alert("请填写行驶里程")
                    Toast('请填写行驶里程')
                    return false;
                }else if(name == ""){
                    //alert("请填写您的称呼")
                    Toast('请填写您的称呼')
                    return false;
                }else if(phone == ""){
                    //alert("请填写联系电话")
                    Toast('请填写联系电话')
                    return false;
                }

                if(!(/^[\u4E00-\u9FA5]{2,6}$/.test(name))){
                    Toast('请填写您的称呼（2-6字）')
                    return false;
                }

                var myreg = /^(((13[0-9]{1})|(15[0-9]{1})|(18[0-9]{1})|(17[0-9]{1}))+\d{8})$/;
                if (!myreg.test(phone)) {
                    Toast('手机号有误')
                    return false;
                }else if (phone.length < 11) {
                    Toast('手机号长度有误')
                    return false;
                }

                if(this.$store.state.token == undefined){
                    request({
                        url: '/used_car/retail/collectCar/create',
                        method: 'post',
                        data:{
                            modelName:brand,
                            registrationTime : _this.currentDate,
                            mileage:mileage,
                            name:name,
                            phone:phone,
                            remark:information,
                            shopId:_this.shopListId
                        }
                    }).then(res=>{
                        //console.log(res,"cs")

                        if(res.code == "200"){
                            // Toast.success('提交成功,即将返回首页');
                            // setTimeout(function () {
                            //     wx.miniProgram.switchTab({
                            //         url: '/pages/main/index/index'//小程序链接会员中心
                            //     });
                            // },2000)

                            _this.$router.push({ path: '/Collect/Publish/Succeed', query: { id: res.data }})
                        }
                    });
                }else{
                    request({
                        url: '/member/collectCar/create',
                        method: 'post',
                        data:{
                            modelName:brand,
                            registrationTime : _this.currentDate,
                            mileage:mileage,
                            name:name,
                            phone:phone,
                            remark:information,
                            shopId:_this.shopListId
                        }
                    }).then(res=>{
                        //console.log(res,"cs")

                        if(res.code == "200"){
                            _this.$router.push({ path: '/Collect/Publish/Succeed', query: { id: res.data }})
                        }
                    });
                }
            },
            toMember(val) {
                let _this=this;
                let Ymileage=_this.Ymileage;
                if(val == '.'){
                    val = '';
                }
                let arr;
                arr = val.split(".");
                arr[0]=arr[0]+"";
                arr[1]=arr[1]+"";
                if(arr[1] == "undefined"){
                    arr[1]="";
                }
                //console.log(Ymileage,val,arr,arr[0].length,arr[1].length)
                if(arr[0].length > 3 || arr[1].length > 2){
                    _this.mileage=Ymileage;
                }else{
                    _this.Ymileage=val;
                }

            },
            onClickLeft() {
                this.$router.push('/Collect');
            },
            onConfirmBrand(value) {
                this.brand = value;
                this.showColumns = false;
            },
            onConfirmTime(value) {
                //console.log(new Date(value).getFullYear()+'-'+(new Date(value).getMonth()+1))
                //console.log(value.getTime())
                this.currentDate=value.getTime();
                this.time = new Date(value).getFullYear()+'-'+(new Date(value).getMonth()+1)+'-'+new Date(value).getDate();
                this.showTime = false;
            },
            thiw(e) {
                //选择门店
                //console.log(e)
                let _this=this;
                _this.shopListStatus=e;
                _this.shopListId=_this.shopList[e].id;
            }
        },
        mounted: function () {
            var _this = this;

            //_this.$store.commit('setToken', "c866fa8a-7c1c-439b-b236-c1af459a25d0")
            //_this.$store.commit('setLngLat', "22.26666,113.54342")

            let lngLat = _this.$store.state.lngLat;
            //获取门店
            request({
                url: '/used_car/retail/shopList',
                method: 'GET',
                data:{
                    lngLat:lngLat
                }
            }).then(res=>{
                console.log(res.data)
                var re=res.data;
                var num=1;
                for(var i=0;i<re.length;i++){
                    if(lngLat == ""){

                        re[i].distance="";

                        _this.shopListId=re[0].id;

                    }else{

                        re[i].distance=re[i].distance/1000+"km";

                        if(num==1){

                            if(re[i].distance != "0km"){

                                _this.shopListId=re[i].id;

                                _this.shopListStatus=i;

                                //console.log(i)

                                num=num+1;

                            }

                        }

                    }
                }
                _this.shopList=re;

            });

            var detail = JSON.parse(_this.$route.query.detail);
            if(detail!= undefined){
                _this.brand=detail.carModel;
                _this.currentDate=detail.registrationTime;
                _this.time=new Date(detail.registrationTime).getFullYear()+'-'+(new Date(detail.registrationTime).getMonth()+1)+'-'+new Date(detail.registrationTime).getDate();
                _this.mileage=detail.mileage;
                _this.phone=detail.mobile;
            }

        }
    };
</script>

<style lang="less">
  .goods {
    padding-bottom: 0 !important;

    &-swipe {
      img {
        width: 100%;
        display: block;
      }
    }

    &-title {
      font-size: 16px;
    }

    &-price {
      color: #f44;
    }

    &-express {
      color: #999;
      font-size: 12px;
      padding: 5px 15px;
    }

    &-cell-group {
      margin: 15px 0;

      .van-cell__value {
        color: #999;
      }
    }

    &-tag {
      margin-left: 5px;
    }
  }

  body{
    background: #F2F2F2;
  }
  .flex-start{
    display:flex;
    flex-direction: row;
    align-items:center;
    justify-content:flex-start;
  }
  .flex-center{
    display:flex;
    flex-direction: row;
    align-items:center;
    justify-content:center;
  }
  .flex-column{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .van-nav-bar__title{
    font-size: .486rem;
    color: #333;
  }
  .van-nav-bar .van-icon{
    font-size: .486rem;
    color: #333;
  }
  .van-cell{
    padding: 0 .405rem;
    height: 1.377rem;
    font-size: 0.378rem;
  }
</style>
